import React from 'react'
import { IconButton, Tooltip } from '@material-ui/core'
import { ReactComponent as BackIcon } from 'src/assets/RiskReport_images/backIcon.svg'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'

const NavigateBackButton = ({ title, handleClick, tooltipTitle, size }) => {
  const classes = useStyles()
  return (
    <>
      <span className={classes.root} id='backButton' data-test='backButton'>
        <Tooltip title={tooltipTitle} className={classes.icon}>
          <IconButton
            aria-label={tooltipTitle}
            size={size ?? 'small'}
            onClick={handleClick}
            data-test='buttonClick'
          >
            <BackIcon data-test='backIcon' />
          </IconButton>
        </Tooltip>
        <span className={classes.title}>{title}</span>
      </span>
    </>
  )
}

export default NavigateBackButton

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
  },
  icon: {
    flexBasis: '36px',
    flexShrink: 0,
    '& svg': {
      maxWidth: '100%',
    },
  },
  title: {
    marginLeft: '10px',
    color: COLORS.DARK_PINK,
    fontWeight: '600',
  },
})
